<template>
    <span
        class="text-danger float-left mr-1">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Excluir Meta"
            @click.stop="confirmarExcluir(meta.metaId)"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        acao: Object,
        meta: Object,
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir(id) {
            this.$swal({
                title: 'Excluir',
                html: 'Deseja Excluir a Meta ?',
                icon: 'error',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluir(id)
                }
            })
        },

        excluir(id) {
            this.$store.dispatch('addRequest')
            this.dataServicos.excluirMeta(id, this.acao.acaoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Meta excluída com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    },
}
</script>
